export const SKIP_AUTHENTICATION_WHITELIST = [
  "AppQuery_v1",
  "ContextualAssignment",
  "LearningPlanAssignment",
  "AuthByURL",
  // "AuthRefresh",
];
